import { atom } from 'jotai';

import { AssetTypeFormState } from '~/modules/transportation/types';

const initialState: AssetTypeFormState = {
  name: '',
  description: '',
  capacity: 0,
};

export const $assetTypeForm = atom<AssetTypeFormState>(initialState);

export const $updateAssetTypeForm = atom(
  null,
  (get, set, update: Partial<AssetTypeFormState>) => {
    const current = get($assetTypeForm);
    set($assetTypeForm, { ...current, ...update });
  },
);
